var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.displayStatus)?_c('b',{staticClass:"label",class:_vm._f("statusColor")(_vm.displayStatus)},[_vm._v("\n        "+_vm._s(_vm.displayStatusName)+"\n    ")]):_c('span',[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }